import React from 'react';
import { TreeSelect } from 'antd';
import { ScenarioDropdown } from './styles';

const ScenarioPicker = ({
  active, scenarios, onChange, ...rest
}) => (
  <ScenarioDropdown
    width="200"
    showSearch
    value={`${active}`}
    treeNodeFilterProp="title"
    onChange={id => onChange(id)}
    dropdownClassName="DCRPScenarioOption"
    searchPlaceholder="Search scenarios"
    dropdownStyle={{ maxHeight: 400, overflow: 'hidden' }}
    {...rest}
  >
    {
      scenarios.sort((a, b) => (a.id - b.id)).map(s => (
        <TreeSelect.TreeNode
          key={s.id}
          value={s.id}
          title={s.name.value || s.name}
          disableCheckbox
          isLeaf
        />
      ))
    }
  </ScenarioDropdown>
);

export default ScenarioPicker;
